export const publicQueryKeys = {
  /** The whole public payload. Admin mutations must invalidate this. */
  site: ['public', 'site'] as const,
};
